import BookingRoleWorkerSource from '@/models/BookingRoleWorkers/BookingRoleWorkerSource';

export default class QuickBookRequest {
    bookingRoleId: string;
    workerId: string;
    shiftIds: string[];
    payRate: number;
    chargeRate: number;
    source: BookingRoleWorkerSource;
}